var _path, _g, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmptyServiceModels = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 156,
  height: 177,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M73.868 154.7c40.715 0 73.724-33.008 73.724-73.87 0-40.86-33.154-73.868-73.724-73.868C33.153 6.962.145 39.97.145 80.83S33.153 154.7 73.868 154.7ZM142.794 32.409a5.962 5.962 0 1 0 0-11.924 5.962 5.962 0 0 0 0 11.924ZM151.52 9.143A4.071 4.071 0 1 0 151.519 1a4.071 4.071 0 0 0 .001 8.143ZM4.072 32.264a4.072 4.072 0 1 0 0-8.144 4.072 4.072 0 0 0 0 8.143Z",
  fill: "#EAEEF9"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m124.036 43.896 1.163 93.645c0 3.199-2.617 5.671-5.816 5.671H28.064c-3.198 0-5.816-2.617-5.816-5.671v-120.4c0-3.2 2.617-5.671 5.816-5.671h66.163l29.809 32.426Z",
  fill: "url(#b)"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M66.744 124.454H63.4c-.727 0-1.31-.727-1.31-1.599 0-.873.582-1.6 1.31-1.6h3.344c.727 0 1.309.727 1.309 1.6 0 1.018-.582 1.599-1.309 1.599Z",
  fill: "#CED7E2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M56.564 124.454H37.08c-.727 0-1.309-.727-1.309-1.599 0-.873.582-1.6 1.31-1.6h19.484c.727 0 1.31.727 1.31 1.6 0 1.018-.583 1.599-1.31 1.599ZM81.43 31.1H37.66c-1.017 0-1.89-.872-1.89-1.89 0-1.018.873-1.89 1.89-1.89h43.77c1.018 0 1.89.872 1.89 1.89 0 1.018-.872 1.89-1.89 1.89ZM54.529 41.57H37.66c-1.018 0-1.89-.873-1.89-1.89 0-1.018.872-1.89 1.89-1.89h16.722c1.018 0 1.89.872 1.89 1.89 0 1.017-.872 1.89-1.744 1.89ZM94.227 11.47v25.883c0 3.635 3.199 6.543 6.834 6.543h22.975",
  fill: "#D5DDEA"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M131.016 145.394c-1.454 0-2.908-.582-4.072-1.891l-24.283-24.283-.873.581c-7.852 5.817-17.013 8.87-26.32 8.87-11.196 0-22.393-4.507-30.681-12.36-8.725-8.288-13.523-19.485-13.523-31.7 0-24.283 19.776-44.06 44.06-44.06 16.576 0 31.117 8.726 38.97 23.558 7.706 14.686 6.689 31.845-2.763 45.659l-.582.872 24.429 24.429c2.472 2.472 1.891 4.944 1.454 6.253-1.163 2.327-3.489 4.072-5.816 4.072ZM75.323 52.621c-17.74 0-31.99 14.396-31.99 31.99 0 20.067 16.431 32.137 32.427 32.137 9.742 0 18.612-4.363 24.865-12.215 7.707-9.597 9.015-22.539 3.635-33.736-5.525-11.196-16.577-18.176-28.937-18.176Z",
  fill: "#989FB0"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M61.511 89.847c1.89 0 3.49-1.6 3.49-3.49 0-1.89-1.6-3.49-3.49-3.49-1.89 0-3.49 1.6-3.49 3.49 0 1.89 1.6 3.49 3.49 3.49ZM88.264 89.847c1.89 0 3.49-1.6 3.49-3.49 0-1.89-1.6-3.49-3.49-3.49-1.89 0-3.49 1.6-3.49 3.49 0 2.035 1.6 3.49 3.49 3.49ZM61.374 74.81l-7.677 4.146 1.036 1.919 7.677-4.145-1.036-1.92ZM87.79 74.755l-1.036 1.92 7.678 4.144 1.036-1.92-7.678-4.144ZM74.887 97.99c2.249 0 4.072-1.368 4.072-3.054 0-1.687-1.823-3.054-4.072-3.054s-4.072 1.367-4.072 3.054c0 1.686 1.823 3.053 4.072 3.053Z",
  fill: "#989FB0"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 73.69,
  y1: 8.422,
  x2: 73.69,
  y2: 144.633,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDFEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#ECF0F5"
})), /*#__PURE__*/React.createElement("filter", {
  id: "a",
  x: 0.248,
  y: 0.469,
  width: 146.951,
  height: 175.743,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 11
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 11
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5606_67490"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5606_67490",
  result: "shape"
})))));
export default SvgEmptyServiceModels;